import { NAVIGATION_TABS } from '@/components/pages/page-market-detail-sushi/page-market-detail-sushi';


export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('toggle');
    },
    goToMarketTab(name) {
      const el = document.querySelector(`.tabs__link-name-${name}`);
      if (el !== null) {
        el.click();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/bottom-betslip-shortcut-widget/bottom-betslip-shortcut-widget.js